import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=5ee5e9bc&scoped=true&"
import script from "./CategoryTabs.vue?vue&type=script&lang=js&"
export * from "./CategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTabs.vue?vue&type=style&index=0&id=5ee5e9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee5e9bc",
  null
  
)

export default component.exports